import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import ToolsForm from './components/ToolsForm'

const ToolsFormPage = () => {
    const navigate = useNavigate()
    const { toolId } = useParams()
    const isEditMode = !!toolId

    const goToList = () => {
        navigate('/master/tools-master')
    }

    return (
        <div className="w-full px-6 pt-6 bg-white dark:text-gray-200 dark:bg-slate-800 rounded-lg border border-gray-200 dark:border-slate-800 shadow-md">
            <div className="mb-6">
                <h2 className="text-2xl font-bold text-gray-800 dark:text-white">
                    {isEditMode ? 'Edit Tool' : 'Create Tool'}
                </h2>
                <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                    Manage tool details and configurations
                </p>
            </div>

            <ToolsForm
                editToolId={toolId}
                onCancel={goToList}
                onSuccess={goToList}
            />
        </div>
    )
}

export default ToolsFormPage
